<template>
    <div class="bonuses">
        <grid
            :fullGrid="true"
            :passedData="gridData"
            identificator="id"
            :columns="columns"
            :passedCount="dataCount"
            :passedPageSize="15"
            :title="$t('ACCOUNT_CARDS__BONUS_WAGER_ITEMS')"
            @pageChanged="pageChangeHandler"
            @trClicked="trClickHandler"
        />
        <custom-snackbar
            :purpose="mainSnackbar.purpose"
            :text="mainSnackbar.text"
            v-if="mainSnackbar.visible"
            @close="mainSnackbar.visible = false"
        />
    </div>
</template>

<script>
import Grid from '@/components/ReusableComponents/Grid/Grid.vue'
import CustomSnackbar from '@/components/ReusableComponents/CustomSnackbar/CustomSnackbar.vue'
import axios from '@/Helpers/AxiosInstance.js'
import { addHours } from '@/Helpers/HelperFunctions'
export default {
    components: {
        Grid, CustomSnackbar,
    },
    created() {
        this.cardID = this.$route.query.cardID
        this.getData()
    },
    data() {
        return {
            gridData: [],
            dataCount: 0,
            status: null,
            pageSize: 20,
            currentPage: 1,
            cardID: null,
            statuses: {
                1: 'Active',
                2: 'Paused',
                3: 'Realized',
                4: 'Canceled',
            },
            mainSnackbar: {
                purpose: 'error',
                text: '',
                visible: false,
            }
        }
    },
    computed: {
        isSuperVisor() {
            return this.$store.state.shop
        },
        columns() {
            var cols = [
                {
                    title: 'Create Date',
                    key: 'createDate',
                    customTemplate: (item, val) => addHours(val, 2),
                },
                {
                    title: 'Bonus Name',
                    key: 'bonusTemplateName',
                },
                {
                    title: 'Activation Type',
                    key: 'activatorType',
                },
                {
                    title: 'Bonus Amount',
                    key: 'bonusAmountDecimal',
                    customTemplate: (item, val) =>
                        val + ' ' + item.currencyName,
                },
                {
                    title: 'Realization Rollover',
                    key: 'realizationRolloverDecimal',
                    customTemplate: (item, val) =>
                        val + ' ' + item.currencyName,
                },
                {
                    title: 'Progress',
                    key: 'currentRolloverDecimal',
                    customTemplate: (item, val) => this.getProgressBar(val, item.realizationRolloverDecimal),
                },
                {
                    title: 'Status',
                    key: 'status',
                    customTemplate: (item, val) => this.statuses[val]
                },
            ]
            if(this.isSuperVisor) {
                cols.push({
                    title: 'Cancel Bonus',
                    key: '',
                    customTemplate: (item) => item.status == 1 
                        ? `<button class="btn cancel">Cancel</button>`
                        : ''
                })
            }
            return cols
        },
        statusCodes() {
            return this.$store.state.statusCodes
        },
    },
    methods: {
        getProgressBar(amount, totalAmount) {
            var percentage = (amount / totalAmount * 100).toFixed(2)
            percentage = percentage > 100 ? 100 : percentage
            var colorClass = 'red'
            if(percentage > 33.33) colorClass = 'yellow'
            if(percentage > 66.66) colorClass = 'green'

            var progressToDisplay = percentage < 3 ? 3 : percentage
            return  `
                        <div class="progress-bar" title="${percentage + '%'}">
                            <div
                                class="percentage ${colorClass}"
                                style="width: ${progressToDisplay + '%'};"
                            >
                        </div>
                    `
        },
        getData() {
            axios
                .get('WebShop/GetCustomerBonuses', { params: {
                    CardId: this.cardID,
                    Status: this.status,
                    CurrentPage: this.currentPage,
                    PageSize: this.pageSize,
                }})
                .then(resp => {
                    this.gridData = resp.data.response.bonusReportWagerItems
                    this.dataCount = resp.data.response.count
                })
        },
        pageChangeHandler(page) {
            this.currentPage = page
            this.getData()
        },
        trClickHandler(element, e) {
            if(e.target.matches('.btn.cancel')) {
                axios
                    .post('WebShop/CancelWagerItem', {
                        userWagerItemId: element.id
                    })
                    .then(resp => {
                        if(resp.data.status == 1) {
                            this.getData()
                            this.mainSnackbar.purpose = 'success'
                            this.mainSnackbar.text = 'Successfully Canceled!'
                            this.mainSnackbar.visible = true
                        }
                        else {
                            this.showError(resp.data.status)
                        }
                    })
                    .catch(() => {
                        this.showError()
                    })
            }
        },
        showError(status) {
            this.mainSnackbar.visible = true
            this.mainSnackbar.purpose = 'error'
            this.mainSnackbar.text = 'An Error Occurred While Canceling!'
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code) this.mainSnackbar.text = this.$t('STATUS-CODE__' + code.value)
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/ .progress-bar {
    height: 6px;
    border: 1px solid rgb(163, 163, 163);
    border-radius: 20px;

    .percentage {
        height: 100%;
    }

    .red {
        background-color: #F44336;
    }

    .yellow {
        background-color: #FFC107;
    }

    .green {
        background-color: #8BC34A;
    }
}

/deep/ .btn.cancel {
    background-color: $red;
}
</style>